<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        账号注册
      </div>
    </div>
    <form class="form">
      <div class="cut_login">
        <router-link
          to="/login"
        >
          登陆
          <div class="line" />
        </router-link>
        <router-link
          class="cur"
          to="/register"
        >
          注册
          <div class="line" />
        </router-link>
      </div>
      <div class="item">
        <span class="icon">
          <img
            src="../images/login/tel.png"
            alt=""
          >
        </span>
        <input
          v-model.trim="data.mobile"
          type="text"
          class="inp"
          placeholder="请输入手机号码"
        >
      </div>
      <!-- <div class="item">
				<span class="icon">
					<img src="../images/login/p1.png" alt="">
				</span>
				<input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
			</div> -->
      <div class="item">
        <span class="icon">
          <img
            src="../images/login/lock.png"
            alt=""
          >
        </span>
        <input
          v-model.trim="data.password"
          :type="password"
          class="inp"
          placeholder="请输入登录密码"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>
      <div class="item">
        <span class="icon">
          <img
            src="../images/login/lock.png"
            alt=""
          >
        </span>
        <input
          v-model.trim="data.spassword"
          :type="password"
          class="inp"
          placeholder="请再次输入登录密码"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div>

      <!-- 			<div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->

      <div class="item">
        <span class="icon">
          <img
            src="../images/login/p2.png"
            class="people"
            alt=""
          >
        </span>
        <input
          v-model.trim="data.t_mobile"
          type="text"
          class="inp"
          placeholder="请输入邀请码"
        >
      </div>
      <div class="protocol">
        注册即同意
        <a
          href="javascript:;"
          @click="userAgreement"
        >《用户协议》</a>和
        <a
          href="javascript:;"
          @click="privacyStatement"
        >《隐私政策》</a>
      </div>
    </form>
    <div
      class="basic_btn sbtn"
      :class="
        data.mobile == '' ||
          data.password == '' ||
          data.spassword == ''
          ? 'no_touch'
          : ''
      "
      @click="submit"
    >
      立即注册
    </div>
    <van-dialog
      v-model="statement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="privacyStatementHide"
    >
      <div class="block">
        <div class="block-title">
          隐私政策
        </div>
        <div class="p_agr">
          <p>
            我们重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
          </p>
          <p>
            您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
          </p>
          <p>
            如对本《隐私政策》或相关事宜有任何问题，请通过zhongshunleyi@163.com与我们联系。
          </p>
          <p>我们可能收集的信息</p>
          <p>
            我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
          </p>
          <p>您提供的信息</p>
          <p>
            您在使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件或银行卡号等；
          </p>
          <p>
            您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
          </p>
          <p>其他方分享的您的信息</p>
          <p>其他方使用我们的服务时所提供有关您的共享信息。</p>
          <p>我们获取的您的信息</p>
          <p>您使用服务时我们可能收集如下信息：</p>
          <p>
            日志信息，指您使用我们的服务时，系统可能通过cookies、web
            beacon或其他方式自动采集的技术信息，包括：
          </p>
          <p>
            设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
          </p>
          <p>
            在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情
          </p>
          ；
          <p>
            有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；
          </p>
          <p>
            位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：
          </p>
          <p>
            您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；
          </p>
          <p>
            您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息；
          </p>
          <p>
            您可以通过关闭定位功能，停止对您的地理位置信息的收集。
          </p>
          <p>我们可能如何使用信息</p>
          <p>
            我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：
          </p>
          <p>向您提供服务；</p>
          <p>
            在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
          </p>
          <p>帮助我们设计新服务，改善我们现有服务；</p>
          <p>
            使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；
          </p>
          <p>向您提供与您更加相关的广告以替代普遍投放的广告；</p>
          <p>
            评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；
          </p>
          <p>软件认证或管理软件升级；</p>
          <p>让您参与有关我们产品和服务的调查。</p>
          <p>
            为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
          </p>
          <p>您如何访问和控制自己的个人信息</p>
          <p>
            我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。
          </p>

          我们可能分享的信息
          除以下情形外，未经您同意，我们不会与任何第三方分享您的个人信息：
          我们可能将您的个人信息与第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：
          向您提供我们的服务；
          实现“我们可能如何使用信息”部分所述目的；
          履行我们在本《隐私政策》中的义务和行使我们的权利；
          理解、维护和改善我们的服务。
          如我们与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。
          随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。
          我们还可能为以下需要而保留、保存或披露您的个人信息：
          遵守适用的法律法规； 遵守法院命令或其他法律程序的规定；
          遵守相关政府机关的要求；
          为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们、其他用户的人身和财产安全或合法权益所合理必需的用途。
          信息安全
          我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。
          我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
          您分享的信息
          我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。
          因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。
          您分享的敏感个人信息
          某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。
          请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。
          您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。
          我们可能如何收集信息
          我们或我们的第三方合作伙伴，可能通过cookies和web
          beacon收集和使用您的信息，并将该等信息储存为日志信息。
          我们使用自己的cookies和web
          beacon，目的是为您提供更个性化的用户体验和服务，并用于以下用途：
          记住您的身份。例如：cookies和web
          beacon有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；
          分析您使用我们服务的情况。例如，我们可利用cookies和web
          beacon来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎；
          广告优化。Cookies和web
          beacon有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。
          我们为上述目的使用cookies和web
          beacon的同时，可能将通过cookies和web
          beacon收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。
          我们的产品和服务上可能会有广告商或其他合作方放置的cookies和web
          beacon。这些cookies和web
          beacon可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies和web
          beacon收集和使用该等信息，不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies或web
          beacon承担责任。 您可以通过浏览器设置拒绝或管理cookies或web
          beacon。但请注意，如果停用cookies或web
          beacon，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低。
          广告服务
          我们可能使用您的相关信息，向您提供与您更加相关的广告。
          我们也可能使用您的信息，通过我们的服务、电子邮件或其他方式向您发送营销信息，提供或推广我们或第三方的如下商品和服务：
          我们的服务，我们的关联公司和合作伙伴的商品或服务，包括即时通讯服务、网上媒体服务、互动娱乐服务、社交网络服务、付款服务、互联网搜索服务、位置和地图服务、应用软件和服务、数据管理软件和服务、网上广告服务、互联网金融，以及其他社交媒体、娱乐、电子商务、资讯和通讯软件或服务（统称“互联网服务”）；
          第三方互联网服务供应商，以及与下列有关的第三方商品或服务：食物和餐饮、体育、音乐、电影、电视、现场表演及其他艺术和娱乐、书册、杂志和其他刊物、服装和配饰、珠宝、化妆品、个人健康和卫生、电子、收藏品、家用器皿、电器、家居装饰和摆设、宠物、汽车、酒店、交通和旅游、银行、保险及其他金融服务、会员积分和奖励计划，以及我们认为可能与您相关的其他商品或服务。
          如您不希望我们将您的个人信息用作前述广告用途，您可以通过我们在广告中提供的相关提示，或在特定服务中提供的指引，要求我们停止为上述用途使用您的个人信息。
          我们可能向您发送的邮件和信息 邮件和信息推送
          您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。
          与服务有关的公告
          我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。
          隐私政策的适用例外
          我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：
          您利用
          “分享”键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；
          我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。
          该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非《通用服务条款》或本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。
          未成年人使用我们的服务
          我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本《隐私政策》，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意和指导。
          隐私政策的适用范围
          除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策。=
          请您注意，本《隐私政策》不适用于以下情况：
          通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；
          通过在我们服务中进行广告服务的其他公司或机构所收集的信息。
          变更
          我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="agreement"
      confirm-button-color="#fb661e"
      :close-on-click-overlay="true"
      @click="agreementHider"
    >
      <div class="block">
        <div class="block-title">
          用户协议
        </div>
        <div class="p_agr">
          <p>用户行为规范</p>
          <p>
            1、用户在本网站注册时，不得使用虚假身份信息。用户应当妥善保存其账户信息和密码，由于用户泄密所导致的损失需由用户自行承担。如用户发现他人冒用或盗用其账户或密码，或其账户存在其他未经合法授权使用之情形，应立即以有效方式通知本公司。用户理解并同意本公司有权根据用户的通知、请求或依据判断，采取相应的行动或措施，包括但不限于冻结账户、限制账户功能等，本公司对采取上述行动所导致的损失不承担除法律有明确规定外的责任。
          </p>
          <p>
            2、用户在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，包括但不限于：
          </p>
          <p>
            （1）发布、传送、传播、储存危害国家安全统一、破坏社会稳定、违反公序良俗、侮辱、诽谤、淫秽、暴力以及任何违反国家法律法规的内容；
          </p>
          <p>
            （2）发布、传送、传播、储存侵害他人知识产权、商业秘密等合法权利的内容；
          </p>
          <p>（3）恶意虚构事实、隐瞒真相以误导、欺骗他人；</p>
          <p>（4）发布、传送、传播广告信息及垃圾信息；</p>
          <p>（5）其他法律法规禁止的行为。</p>
          <p>
            3、用户不得利用本服务进行任何有损本公司及其关联企业之权利、利益及商誉，或其他用户合法权利之行为。
          </p>
          <p>
            4、用户不得基于本服务从事制作、使用、传播“私服”、“外挂”等侵害本公司合法权益的行为。如有违反，本公司将依据中国现行法律法规及本公司的相关规定予以处理。
          </p>
          <p>
            5、虚拟财产转移服务外，用户不得通过任何方式直接或变相进行账号资产的转移。
          </p>
          <p>
            6、用户不得从事作弊等损害公平性的行为。用户承诺接受本公司对其游戏数据进行分析，当本公司发现其数据异常时，本公司可根据自己的独立判断认定其为作弊。
          </p>
          <p>
            7、用户不得从事任何利用本公司平台系统漏洞进行有损其他用户、本公司或互联网安全的行为。
          </p>
          <p>
            8、用户知悉并确认，本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式，向用户发出关于本服务的通知、规则、提示等信息，均为有效通知。该等信息一经公布或发布，即视为已送达至用户。
          </p>
          <p>广告信息和促销</p>
          <p>
            1、用户同意接受本公司通过公告、邮件、短信、账户通知以及用户在账户中登记的即时通讯工具等方式发送的有关本服务，或本公司、本公司之关联企业或与本公司有合作关系的第三方相关的商品、服务促销或其他商业信息。
          </p>
          <p>
            2、本公司在本服务中可能提供与其他互联网之网站站点或资源的链接，本公司对存在或源于此类网站站点或资源的任何内容、广告、产品或其他资料不予保证或负责；如该链接所载的内容或搜索引擎所提供之链接的内容侵犯用户权利，本公司声明与上述内容无关，且不承担除法律有明确规定外的责任。
          </p>
        </div>
      </div>
    </van-dialog>
    <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img
        class="kefu_img"
        src="../images/index/kefu.png"
      >
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Checkbox, Dialog } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Checkbox)
    .use(Dialog);

export default {
    name: "Register",
    data() {
        return {
            agreement: false,
            statement: false,
            show_kefu: false,
            msg_show: true,
            password: "password",
            data: {
                password: "",
                spassword: "",
                mobile: "",
            },
        };
    },
    created() {
        this.$parent.footer("user", false);
        this.getparams();
        // 安卓返回IMEI，苹果返回UID值
        /*BSL.PhoneID('callName');
			window.callName = this.methodName;
			// 获取手机OAID
			BSL.GetOAID('getExternalInfo');
			window.getExternalInfo = this.getExternalInfoData; */
    },
    mounted() {
        var that = this;
        document.body.addEventListener(
            "scroll",
            function() {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function(ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
    },
    methods: {
        kefu_to() {
            if (this.show_kefu) {
                this.$router.push("/kefu");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        methodName(r) {
            this.data.imei = r;
        },
        getExternalInfoData(info) {
            var info = JSON.parse(info);
            console.log(info);
            if (info.code == 0) {
                this.data.oaid = info.oaid;
            }
        },
        getparams() {
            var m = this.$route.query.m;
            this.data.t_mobile = m;
        },
        submit() {
            if (!this.data.mobile) {
                this.$toast("手机号不能为空");
                return false;
            }
            if (!this.data.password) {
                this.$toast("密码不能为空");
                return false;
            }
            if (!this.data.spassword) {
                this.$toast("确认密码不能为空");
                return false;
            }

            if (this.data.password != this.data.spassword) {
                this.$toast("两次登录密码不一致");
                return false;
            }
            if (!this.data.t_mobile) {
                this.$toast("邀请码不能为空");
                return false;
            }

            Fetch("/index/register", {
                ...this.data,
            }).then(() => {
                this.$toast("您已注册成功，请登录");
                this.$router.replace("/login");
            });
        },
        userAgreement() {
            this.agreement = true;
        },
        agreementHider() {
            this.agreement = false;
        },
        privacyStatement() {
            this.statement = true;
        },
        privacyStatementHide() {
            this.statement = false;
        },
    },
};
</script>

<style lang="less" scoped>
.login_bg {
    width: 100%;
    height: 178px;
    background: url(../images/login/login_bg.png) no-repeat center center;
    background-size: 100% 100%;
    overflow: hidden;
}

.basic_wrap .form {
    margin: -115px auto 0 auto;
    width: 335px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 31px 24px 31px 24px;
}

.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #ceced0;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #f12211;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #f12211, #f18a11);
        }
    }
}

.block {
    width: 100%;
    height: 100%;
    // overflow:hidden;
    // margin: 10% auto;
    font-size: 15px;
    justify-content: center;
    background-color: #fff;
    border-radius: 5px;

    .block-title {
        display: block;
        font-weight: bolder;
        line-height: 39px;
        height: 39px;
        text-align: center;
    }

    .p_agr {
        // padding-top:30rpx;
        font-size: 12px;
        /*font-weight: bolder;*/
        line-height: 20px;
        padding: 0px 10px;
        height: 388px;
        /*overflow: hidden;*/
        // overflow: auto;
        -webkit-overflow-scrolling: touch;
        overflow-y: scroll;
    }

    .div_qd {
        width: 60px;
        height: 25px;

        span {
            width: 60px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            justify-content: center;
            background: #fb661e;
            border-radius: 10px;
            padding: 1px 5px;
            color: #fff;
        }

        margin: 10px auto;
    }
}

.item {
    height: 58px;
    border-bottom: 1px solid #f0f1f3;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 4px;

    .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 28px;
        height: 24px;
        .people {
            width: 23px;
            height: 20px;
        }

        img {
            width: 100%;
            height: 100%;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
        margin-bottom: 3px;
    }
}

.protocol {
    font-size: 12px;
    line-height: 17px;
    margin-top: 20px;
    color: #999999;

    a {
        color: #3d96ff;
    }
}

.basic_btn {
    margin: 36px auto 0 auto;
}
</style>
